import type { Tree } from '@festina-life/api'
import { FilterCheckbox } from '@festina-life/ui/listsAndTables'

import type { BlockFilter } from './types'

type Props = {
  tree: Tree
  blockFilter: BlockFilter
  baseBlocks: Set<string>
  onBlockFilterChanged: (blockFilter: BlockFilter) => void
}

export const BlockTreeNodes = ({
  tree,
  blockFilter,
  baseBlocks,
  onBlockFilterChanged,
}: Props) => {
  const isSelected = blockFilter.selectedBlock === tree.name
  const isBaseBlock = baseBlocks.has(tree.name)

  return (
    <div className="flex flex-col gap-y-2">
      <FilterCheckbox
        label={tree.name}
        checked={isSelected || isBaseBlock}
        disabled={isBaseBlock}
        onChange={() =>
          onBlockFilterChanged(
            isSelected
              ? { mode: 'all', selectedBlock: null }
              : {
                  mode:
                    blockFilter.mode === 'all'
                      ? 'withBaseBlocks'
                      : blockFilter.mode,
                  selectedBlock: tree.name,
                },
          )
        }
      />
      <div className="pl-3">
        {tree.children.map((child) => (
          <BlockTreeNodes
            key={child.name}
            tree={child}
            blockFilter={blockFilter}
            baseBlocks={baseBlocks}
            onBlockFilterChanged={onBlockFilterChanged}
          />
        ))}
      </div>
    </div>
  )
}
